import { Stack, useRouter, useNavigation } from "expo-router";
import { Pressable } from "react-native";
import { Ionicons } from "@expo/vector-icons";
import { useThemeColors } from "@/providers/ThemeProvider";

/**
 * Users management stack layout
 */
export default function UsersLayout() {
  const router = useRouter();
  const navigation = useNavigation();
  const colors = useThemeColors();

  /**
   * Handle back navigation safely
   * If there's no screen to go back to, navigate to tabs
   */
  const handleBack = () => {
    if (navigation.canGoBack()) {
      router.back();
    } else {
      router.replace("/(tabs)/admin");
    }
  };

  return (
    <Stack
      screenOptions={{
        headerShown: true,
        headerStyle: { backgroundColor: colors.surface },
        headerTintColor: "#DC2626",
        headerTitleStyle: { color: colors.text },
        headerLeft: () => (
          <Pressable onPress={handleBack} className="mr-2">
            <Ionicons name="arrow-back" size={24} color="#DC2626" />
          </Pressable>
        ),
      }}
    >
      <Stack.Screen
        name="index"
        options={{
          title: "Gebruikers Beheren",
          headerRight: () => (
            <Pressable
              onPress={() => router.push("/(super-admin)/users/create-dependent")}
              className="ml-2 px-3 py-1.5 rounded-lg flex-row items-center"
              style={{ backgroundColor: "#1D4ED8" }}
              accessibilityRole="button"
              accessibilityLabel="Kind toevoegen"
            >
              <Ionicons name="person-add" size={16} color="#FFFFFF" />
            </Pressable>
          ),
        }}
      />
      <Stack.Screen
        name="[id]"
        options={{ title: "Gebruiker Details" }}
      />
      <Stack.Screen
        name="create-dependent"
        options={{ title: "Kind Toevoegen" }}
      />
      <Stack.Screen
        name="merge"
        options={{ title: "Gebruikers Samenvoegen" }}
      />
    </Stack>
  );
}
